﻿import Vue from "vue";
import PanneauAdministrationVue_ from "../vue/PanneauAdministrationVue";
import common from "../../common";
import utilities_ from "../utilities";
import context_ from "../context";
import HotEditableFormAction_ from "../vue/hotEditable/HotEditableFormAction";
import Pooler_ from "../../core/Pooler";
import FormService_ from "../../services/FormService";
import core from "../../core";

declare function require(module: string): unknown;
const utilities = require("../utilities") as typeof utilities_;
const context = require("../context") as typeof context_;
// const HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction") as HotEditableFormAction_;
// const Pooler = require("../../core/Pooler") as Pooler_;
// const FormService = require("../../services/FormService") as FormService_;
// const PanneauAdministrationVue = require("../vue/PanneauAdministrationVue") as PanneauAdministrationVue_;

interface ISettings {
    /** Valeur de l'attribut HTML "name" du formulaire contenant les champs */
    formName: string;
    /** Valeur de l'attribut HTML "id" du module Vuejs */
    vueElId: string;
    /** URL de l'API qui sera appelée lors de la sauvegarde */
    updateApiUrl: string;
    /** Prefixes des contrôles HTML */
    reinitialiserTacheButtonIdPrefix: string;
    dateDebutTacheInputIdPrefix: string;
    /** Valeurs initiales */
    synchroStatusCode: string;
    synchroStatusDescription: string;
    synchroCurrentStep: string;
    isFermeCacheReady: boolean;
    fermeCacheStatusDescription: string;
    customData?: common.IPostCustomData;
}

class PanneauAdministration implements common.IWebComponent, common.IPoolable {
    private _isInit = false;
    private _formService?: FormService_;
    private _editVue = null as PanneauAdministrationVue_ | null;
    private _pooler?: Pooler_;
    private _vueElId?: string;
    private _updateApiUrl?: string | null;
    private _reinitialiserTacheButtonIdPrefix?: string;
    private _dateDebutTacheInputIdPrefix?: string;
    private _customData = null as common.IPostCustomData | null;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        // Définir les variables locales à partir des settings reçus
        this._vueElId = s.vueElId;
        this._updateApiUrl = s.updateApiUrl || (() => { throw "La propriété 'settings.updateApiUrl' est requise."; })();
        this._reinitialiserTacheButtonIdPrefix = s.reinitialiserTacheButtonIdPrefix;
        this._dateDebutTacheInputIdPrefix = s.dateDebutTacheInputIdPrefix;
        this._customData = s.customData || {};

        // Initialiser les composantes
        this._formService = new FormService_(s.formName);
        this.setupVue(s);

        // Définir les valeurs initiales à l'écran
        this._editVue?.setSynchroStatus(s.synchroStatusCode, s.synchroStatusDescription, s.synchroCurrentStep);
        this._editVue?.setFermeCacheStatus(s.isFermeCacheReady, s.fermeCacheStatusDescription);

        // Plugger le pooler
        this._pooler = context.components.getPooler();
        this._pooler?.registerPoolable(this);

        return context.components.add(this);
    }

    onPooling(poolerFetchArguments: common.IPoolerFetchArguments, info: common.IPoolerInformations) {
        const n = Math.ceil((context.pooler.panneauAdminitrationPoolingFrequencySec / 60) * (60 / info.frequencySec));
        const mustPool = !!info.iteration /* ne pas pooler au premier call */ && info.iteration % n === 0;

        if (mustPool) {
            // Demander au pooler d'extraire l'info pour le panneau d'administration
            poolerFetchArguments.panneauAdministrationFetchArgs = {
                doUpdate: true
            } as common.IPanneauAdministrationFetchArguments;
        }

        return mustPool;
    }

    onPoolingSuccess(responseData: common.IPoolingFetchResponseData) {
        const data = responseData.panneauAdministrationData as common.IPanneauAdministrationPoolingFetchResponseData;
        if (data) {
            this._editVue?.setSynchroStatus(data.synchroStatusCode, data.synchroStatusDescription, data.synchroCurrentStep);
            this._editVue?.setFermeCacheStatus(data.isFermeCacheReady, data.fermeCacheStatusDescription);
        }
    }

    onPoolingError(errors: common.IError[]) {
        const m = context.components.getMessagesManager();
        (errors || []).forEach(x => m.displayErrorAsMessage(x, "PanneauAdministration", true, false));
    }

    private setupVue(s: ISettings) {
        // NB: Les params sont passés ainsi car 'vue-class-component' ne permet pas de les passer par le ctor
        Vue.prototype.$initialData = {
            vueElId: this._vueElId,
            formName: s.formName
        };

        this._editVue = new PanneauAdministrationVue_();
        this._editVue?.shared?.setActionCallback((a: HotEditableFormAction_) => {
            this.onFormAction(a);
        }).setErrorCallback((errors: common.IError[], config?: common.IHotEditableFormConfig) => {
            this.onFormActionError(errors, null, config);
        });
    }

    private onFormAction(action: HotEditableFormAction_) {
        if (!action.isFieldChanged)
            return;

        const actionValue = action.getActionValue();
        const actionType = action.getActionType();
        const fieldType = action.getFieldType();
        const actionId = action.getId();
        const args = {
            posted_actionType: actionType,
            posted_actionValue: actionValue,
            posted_formName: this._editVue?.shared?.getFormName(),
            posted_fieldName: action.getFieldName(),
            posted_currentCulture: context.culture.get(),
            posted_currentUrl: utilities.currentUrl(),
            posted_customData: utilities.ensureCustomDataIsValid(this._customData),
            posted_isControlClick: action.getButtonClickContext().isCtlClick === true
        } as common.IHotEditableFormPostArguments;

        if (actionType === common.HotEditableActionTypes.reset && actionId?.indexOf(this._reinitialiserTacheButtonIdPrefix as any) === 0) {
            // Si l'utilisateur réinitialise une tâche système
            (args as any)['idTache'] = actionId.replace(this._reinitialiserTacheButtonIdPrefix as any, "");
            (args as any)['reinitialiserTache'] = true;
        }

        else if (actionType === common.HotEditableActionTypes.reset && actionId?.indexOf('RefreshCacheFerme') === 0) {
            // Refresh cache ferme       
            (args as any)['refreshCacheFerme'] = true;
        }

        else if (actionType === common.HotEditableActionTypes.reset && actionId?.indexOf('AjouterPeriodeDeclaration') === 0) {
            (args as any)['ajouterPeriodeDeclaration'] = true;
        }

        else if (actionType === common.HotEditableActionTypes.reset && actionId?.indexOf('ForcerProjete') === 0) {
            (args as any)['forcerProjete'] = true;
        }

        else if (fieldType === common.HotEditableFieldTypes.datePicker && actionId?.indexOf(this._dateDebutTacheInputIdPrefix as any) === 0) {
            // Si l'utilisateur redéfini la date de début d'une tâche système
            (args as any)['idTache'] = actionId?.replace(this._dateDebutTacheInputIdPrefix as any, "");
            (args as any)['mettreAJourDateDebutTache'] = true;
            (args as any)['nouvelleDateDebutTache'] = action.getFieldTextualValue();
        }

        this._formService?.validateAndPost(this._updateApiUrl, null, args,
            (data: common.IHotEditableFormResponseData) => {
                this.onFormActionSuccess(action, data);
            },
            (e: any, config: any) => {
                this.onFormActionError(e, action, config);
            }, null, false);
    }

    private onFormActionSuccess(action: HotEditableFormAction_, data?: common.IHotEditableFormResponseData) {
        const actionType = action.getActionType();
        const isButtonClick = action.isButtonClick();
        const needToRefresh = isButtonClick && actionType === common.HotEditableActionTypes.reset;

        if (needToRefresh) {
            this._formService?.displaySuccessMessageFromAction(action, false, true, false);
            utilities.refresh();
        }

        else {
            this._formService?.displaySuccessMessageFromAction(action, true, true, false);
        }
    }

    private onFormActionError(errors: common.IError[], action?: HotEditableFormAction_ | null, config?: common.IHotEditableFormConfig) {
        config = config || {};

        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];

            if (error.code !== 110) {

                if (context.env.currentIsDev || context.env.currentIsLocal) {
                    utilities.printError(error.message + ' (code: ' + error.code + ')');
                    this._formService?.displayErrorImediately(new core.Error("Une erreur système est survenue et est affichée dans la console du navigateur.", error.code));
                }
                else
                    this._formService?.displayErrorImediately(new core.Error(error.message));

                return;
            }

            if (config.disableAutomaticMessages)
                return;

            // Functional
            const fieldFound = this._editVue?.shared?.displayFieldError(this._editVue?.shared?.getFormName(), error, true);
            if (fieldFound) {
                this._formService?.displayNotSavedErrorMessageImediately();
                return;
            }

            this._formService?.displayErrorImediately(new core.Error(error.message));
        }
    }
}

export = PanneauAdministration;